function Banner({ hotels }) {
  return (
    <div className="banner">
      <div className="bannerContent">
        <img className="img-fluid" src={hotels.image} alt="" />
      </div>
    </div>
  );
}
export default Banner;
